import { mount } from "@vue/test-utils";
import LegalText from "@/components/core/LegalText";

jest.mock("@/components/core/LegalText", () => ({
  ...jest.requireActual("@/components/core/LegalText"),
  methods: {
    watch: jest.fn()
  }
}));

describe("LegalText test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(LegalText);
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component LegalText", () => {
    expect(wrapper).toBeDefined();
  });
});
